import { useRef } from 'react';
export const useIsBtnInProgress = (isInProgress, hasErrors)=>{
    const isBtnInProgress = useRef(false);
    if (!isBtnInProgress.current && isInProgress) isBtnInProgress.current = true;
    if (isBtnInProgress.current && hasErrors) isBtnInProgress.current = false;
    return isBtnInProgress.current;
};
